import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import ImageOutlinedIcon from "@material-ui/icons/ImageOutlined";
import { isGreetingMediaVideo } from "../../utils/greetingMediaAttachmentUrl";

const useStyles = makeStyles((theme) => ({
  wrap: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.default,
  },
  thumb: {
    width: 96,
    height: 96,
    objectFit: "cover",
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    flexShrink: 0,
    backgroundColor: theme.palette.action.hover,
  },
  placeholder: {
    width: 96,
    height: 96,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.text.secondary,
  },
  meta: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
  },
  name: {
    wordBreak: "break-all",
    color: theme.palette.text.secondary,
  },
}));

const GreetingMediaAttachmentPreview = ({
  previewUrl,
  fileName,
  file,
  onDelete,
}) => {
  const classes = useStyles();
  const displayName = fileName || file?.name || "";
  if (!displayName) return null;

  const isVideo = isGreetingMediaVideo(file || displayName);
  const hasPreview = Boolean(previewUrl);

  return (
    <Box className={classes.wrap}>
      {hasPreview ? (
        isVideo ? (
          <video
            className={classes.thumb}
            src={previewUrl}
            controls
            muted
            playsInline
          />
        ) : (
          <img
            className={classes.thumb}
            src={previewUrl}
            alt={displayName}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        )
      ) : (
        <Box className={classes.placeholder}>
          <ImageOutlinedIcon fontSize="large" />
        </Box>
      )}
      <Box className={classes.meta}>
        <Typography variant="body2" className={classes.name}>
          {displayName}
        </Typography>
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          startIcon={<DeleteOutlineIcon />}
          onClick={onDelete}
        >
          Remover
        </Button>
      </Box>
    </Box>
  );
};

export default GreetingMediaAttachmentPreview;
